module.exports = __webpack_public_path__ + "static/img/bg_8.c055541.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bg_8.jpg
// module id = N5+d
// module chunks = 1